
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import SearchMixin from '@/views/mixins/SearchMixin'
import {mapGetters} from 'vuex'

export default {
mixins: [SearchMixin],
components: {
Search,
Group,
Cell,
Loading
},
computed: {
...mapGetters([
'bannerColorStart',
'bannerColorEnd'
])
},
}




// WEBPACK FOOTER //
// ./src/views/colortheme/Search.vue